<template>
  <div class="page">
    <Header title="创建订单" />
    <AddressInfo @handle="toReceivingAddress" :selectAddress="selectAddress" isLink></AddressInfo>
    <div v-for="(orderItem, index) in orderItems" :key="index">
      <OrderItemBox :orderItem="orderItem"></OrderItemBox>
      <!-- 赠品 -->
      <!-- <div v-if="presentSelectInfo.presentSelect" class="address-info order-list padding-x-3">
        <van-image class="order-item-img"
          :src="(filePrefix + presentSelectInfo.presentSelectItem.itemDTO.itemImageUri)"></van-image>
        <div class="address-content order-item-content">
          <p class="address-content-l color-green">
            礼品名称：{{ presentSelectInfo.presentSelectItem.itemDTO.itemName }}</p>
          <p class="address-content-l point-red">
            {{ presentSelectInfo.presentSelectItem.addPayTypeName }}：<span>{{ presentSelectInfo.presentSelectItem.addPay
            }}</span>
          </p>
        </div>
        <van-stepper v-model="presentSelectInfo.presentItemQty" />
      </div> -->
    </div>
    <div class="ticket">
      <!-- 优惠券 -->
      <van-cell is-link @click="goSelectCoupon">
        <template #icon>
          <van-icon class="cell-icon" size="0.5rem" :name="getImageUri('/img/coupon-icon@2x.png')"></van-icon>
        </template>
        <template #title>
          <p class="ticket-integration">优惠券
            <span v-if="!selectCouponId">{{ couponCount }}张可用</span>
            <span v-if="selectCouponId && couponType === '03' && exchangeRatio !== '0'">{{ exchangeRatio
              }}折</span>
            <span v-if="selectCouponId && couponType === '03'">使用{{ useCouponCount }}张</span>
            <span v-if="selectCouponId && couponType === '02'">满{{ deductPointLimit }}{{
              pointTypeName
              }}减{{ deductPointValue }}</span>
          </p>
        </template>
        <template #default>
          <span class="color-green" v-if="!selectCouponId">未使用</span>
          <div v-if="showReduceValue" class="margin-top-10 text-align-right">
            <span v-for="item in reduceOrderPoint" :key="'rop_' + item.pointType" class="color-red">-{{
              item.pointTypeName
              }}:
              <span class="padding-right-20 font-size-18">{{ item.pointValue }}</span>
            </span>
          </div>
        </template>
      </van-cell>

      <!-- vip卡 -->
      <van-cell title="VIP卡折扣" v-if="showVipCardReduce()">
        <template #icon>
          <van-icon class="cell-icon" size="0.5rem" :name="getImageUri('/img/coupon-icon@2x.png')"></van-icon>
        </template>
        <template #default>
          <span v-for="item in vipCardDiscountList" :key="'rop_' + item.pointType" class="color-green">{{
            item.pointTypeName
            }}:{{ item.pointValue }} </span>
        </template>
      </van-cell>
      <!-- 满赠活动 -->
      <!-- <h4>满赠活动</h4>
      <el-form>
        <el-form-item>
          <el-radio-group v-model="activityId" class="addressRadio" @change="pushItemInfo">
            <el-radio label="" class="block">暂不参加活动</el-radio>
            <el-radio :label="item.activityId" v-for="item in presentList" :key="item.activityId" class="block">
              {{ item.activityName }}:
              加付{{ item.addPayTypeName }} : {{ item.addPay }} ,
              获赠{{ item.itemDTO.itemName }} ,
              <span v-if="item.downLimit === getPresentItemUpLimit(item)">可兑换 {{ item.downLimit }} 件</span>
              <span v-else>可兑换 {{ item.downLimit }} - {{ getPresentItemUpLimit(item) }} 件</span>
              <el-input-number v-if="item.downLimit !== getPresentItemUpLimit(item) && activityId === item.activityId"
                v-model="presentItem.itemQuantity" :min="item.downLimit" :max="getPresentItemUpLimit(item)" size="small"
                class="shopping-cart-number-small" />
            </el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form> -->
      <!-- <van-cell title="满赠活动" v-if="hasPresent">
        <template #icon>
          <van-icon class="cell-icon" size="0.5rem" :name="getImageUri('/img/coupon-icon@2x.png')"></van-icon>
        </template>
      </van-cell>
      <van-cell v-if="hasPresent">
        <template #title>
          <van-checkbox @click="presentNull">暂不参加活动</van-checkbox>
        </template>
      </van-cell>
      <van-cell v-for="(item, index) in presentList" :key="index">
        <template #title>
          <van-checkbox @click="presentOn(item.activityId)">
            加付{{ item.addPayTypeName }}{{ item.addPay }},获赠{{ item.itemDTO.itemName }},
            <span v-if="item.upLimit == item.downLimit">兑换{{ item.downLimit }}件</span>
            <span v-if="item.upLimit != item.downLimit">可兑换{{ item.downLimit }} - {{ item.upLimit }}件</span>
          </van-checkbox>
        </template>
      </van-cell> -->
      <!-- 当前积分 -->
      <van-cell v-for="currentPointItem in pointList" :key="currentPointItem.pointTypeName">
        <template #title>
          <span class="color-base-green">{{ currentPointItem.pointTypeName }}</span><span>当前积分</span>
        </template>
        <template #icon>
          <van-icon class="cell-icon" size="0.5rem" :name="getImageUri('/img/coupon-icon@2x.png')"></van-icon>
        </template>
        <template #default>
          <span>{{ currentPointItem.pointValue }}分</span>
        </template>
      </van-cell>
      <!-- 运费 -->
      <van-cell>
        <template #title>
          应付运费<span v-if="channelInfo.logisticsPointTypeName">({{ channelInfo.logisticsPointTypeName }})</span>

        </template>
        <template #icon>
          <van-icon class="cell-icon" size="0.5rem" :name="getImageUri('/img/coupon-icon@2x.png')"></van-icon>
        </template>
        <template #default>
          <span>{{ logisticsPointValue }}</span>
        </template>
      </van-cell>

    </div>
    <!-- 底部 -->
    <div class="fixed">
      <div class="point">
        <p v-for="(item, index) in calcFinallPoint" :key="'cop_' + index">
          {{ item.pointTypeName }}: {{ item.pointValue }}
        </p>
      </div>
      <van-button color="#87c0ca" @click="orderCancel">取消订单</van-button>
      <van-button type="primary" @click="handleLogin" :loading="submitLoading"
        :disabled="submitLoading || userRole === '03'">提交订单
      </van-button>
    </div>
    <!-- 活动弹窗 -->
    <!-- <popUpDisplay :show.sync="popUpDisplay.dialog"  :activityPrize="popUpDisplay.activityPrize" :type="popUpDisplay.type"  :isShowClose="popUpDisplay.isShowClose"></popUpDisplay> -->
  </div>
</template>

<script>
import wxAppApi from '@/api/wx-app'
import Header from '@/components/header'
import AddressInfo from '@/components/address-info'
import OrderItemBox from './component/order-item-box'
import centerApi from '@/api/center'
import cartApi from '@/api/cart'
import activityApi from '@/api/activity'
// import popUpDisplay from '../../components/popup-cards.vue'
import { mapState } from 'vuex'
import { mathUtils } from '@/utils/common'
import _ from 'lodash'
export default {
  components: {
    Header,
    AddressInfo,
    OrderItemBox
    // popUpDisplay
  },
  created () {
    if (this.userRole === '03') {
      this.$toast('没有下单权限')
    } else {
      this.init()
    }
  },
  data () {
    return {
      addressList: [],
      selectAddress: {}, // 选择的地址信息
      pointList: [], // 积分
      vipCardInfo: {}, // vip卡
      couponList: [],
      orderItems: [],
      channelInfo: {},
      orderPoint: [],
      presentList: [], // 满减
      quickLogisticsItem: {}, // 加急
      couponType: '', // 卡券类型
      selectCouponId: '', // 卡券ID

      exchangeRatio: 0,
      deductPointLimit: 0,
      pointTypeName: 0,
      deductPointValue: 0,

      logisticsItem: {}, // 运费

      useCouponCount: 0,
      couponCount: 0,

      presentSelectInfo: {
        presentSelect: 0,
        presentSelectItem: {},
        presentItemQty: 0
      },
      vipCardDiscountList: [],
      vipCardDiscountPoint: {},
      couponId: '',
      orderList: [],
      activityId: '',
      presentItem: {},
      submitLoading: false
      // popUpDisplay: {
      //   dialog: false,
      //   activityPrize:{},
      //   type:'order',
      //   isShowClose:true
      // },
    }
  },
  computed: {
    ...mapState({
      filePrefix: state => state.base.ApiEndpoint.fileUrl,
      userRole: state => state.user.userRole, // 01老板，02采购，03小工
      clientInfo: state => state.user.clientInfo
    }),
    // 若下单商品中有除终端支持（210） 分类的商品，则不进行vip卡折扣
    calculatedOrderPoint () {
      const calculatedPoint = _.cloneDeep(this.originalOrderPoint)
      if (this.reduceOrderPoint && this.reduceOrderPoint.length > 0) {
        calculatedPoint.map(point => {
          for (let i in this.reduceOrderPoint) {
            if (this.reduceOrderPoint[i].pointType === point.pointType) {
              point.pointValue = mathUtils.floatSub(point.pointValue, this.reduceOrderPoint[i].pointValue)
            }
          }
        })
      }
      return calculatedPoint
    },
    originalOrderPoint () {
      const orderPoint = []
      this.pointList.map(point => {
        let isSpecial = 0
        let pointValue = 0
        this.orderItems.map(item => {
          if (item.pointType === point.pointType) {
            isSpecial = item.isSpecial
            pointValue = mathUtils.floatAdd(pointValue, mathUtils.floatMul((item.pointValue || 0), item.itemQuantity))
          }
        })
        orderPoint.push({
          pointType: point.pointType,
          pointTypeName: point.pointTypeName,
          isSpecial: isSpecial,
          pointValue: pointValue
        })
      })
      return orderPoint
    },
    reduceOrderPoint () {
      if (!this.selectCouponId) {
        return []
      }
      let selectedCoupon = null
      this.couponList.map(coupon => {
        if (coupon.couponId === this.couponId) {
          selectedCoupon = coupon
        }
      })
      if (!selectedCoupon) {
        return []
      }
      const reducePoint = []
      if (selectedCoupon.couponType === '02') {
        reducePoint.push({
          pointType: selectedCoupon.pointType,
          pointTypeName: selectedCoupon.pointTypeName,
          pointValue: selectedCoupon.deductPointValue
        })
      }
      if (selectedCoupon.couponType === '03') {
        let reducePointValue = 0
        let selectedPointType = ''
        let selectedPointTypeName = ''

        if (selectedCoupon.limitItemId && selectedCoupon.limitItemId === '-1') {
          for (let item in this.orderItems) {
            if (this.orderItems[item].pointType === '1') {
              reducePointValue += parseInt(this.orderItems[item].detailUsePoint * (1 - selectedCoupon.exchangeRatio))
            }
          }
          selectedPointType = this.orderItems[0].pointType
          selectedPointTypeName = this.orderItems[0].pointTypeName
          reducePoint.push({
            pointType: selectedPointType,
            pointTypeName: selectedPointTypeName,
            pointValue: reducePointValue
          })
        } else {
          for (let item in this.orderItems) {
            if (((this.orderItems[item].itemId === selectedCoupon.limitItemId) || (selectedCoupon.couponItemIds.includes(this.orderItems[item].itemId))) && !this.orderItems[item].activityId) {
              // const nowPointValue = parseInt(this.orderItems[item].pointValue * selectedCoupon.exchangeRatio)
              // const oldPointValue = this.orderItems[item].detailUsePoint;
              let nowPointValue
              if (selectedCoupon.couponCount > this.orderItems[item].itemQuantity) {
                nowPointValue = parseInt(this.orderItems[item].pointValue * selectedCoupon.exchangeRatio * this.orderItems[item].itemQuantity)
              } else {
                nowPointValue = parseInt(this.orderItems[item].pointValue * selectedCoupon.exchangeRatio * selectedCoupon.couponCount) + parseInt(this.orderItems[item].itemQuantity - selectedCoupon.couponCount) * this.orderItems[item].pointValue
              }
              const oldPointValue = this.orderItems[item].detailUsePoint
              reducePointValue = oldPointValue - nowPointValue
              selectedPointType = this.orderItems[item].pointType
              selectedPointTypeName = this.orderItems[item].pointTypeName
              break
            }
          }
          reducePoint.push({
            pointType: selectedPointType,
            pointTypeName: selectedPointTypeName,
            pointValue: reducePointValue
          })
        }
      }
      return reducePoint
    },
    showReduceValue () {
      // for (let item in  this.reduceValue) {
      //   for (let item2 in this.orderPointRel) {
      //     if (this.reduceValue[item].type === this.orderPointRel[item2].pointType) {
      //       return true;
      //     }
      //   }
      // }
      // return false;
      return this.reduceOrderPoint && this.reduceOrderPoint.length > 0
    },
    calcFinallPoint () {
      const calcFinallPoint = _.cloneDeep(this.calculatedOrderPoint)
      if (this.vipCardDiscountPoint && this.vipCardDiscountPoint.length > 0) {
        calcFinallPoint.map(point => {
          for (let i in this.vipCardDiscountPoint) {
            if (this.vipCardDiscountPoint[i].pointType === point.pointType) {
              point.pointValue = mathUtils.floatSub(point.pointValue, this.vipCardDiscountPoint[i].pointValue)
            }
          }
        })
      }
      return calcFinallPoint
    },
    freightState () {
      return this.itemPointValueWithoutQuickLogistics < (this.channelInfo.limitOrderPoint || 0)
    },
    itemPointValueAll () {
      let value = 0
      this.calculatedOrderPoint.map(item => {
        value = mathUtils.floatAdd(value, item.pointValue || 0)
      })
      return value
    },
    itemPointValueWithoutQuickLogistics () {
      let quickLogisticsValue = 0
      this.orderItems.map(item => {
        if (item.itemCode === this.quickLogisticsItem.itemCode) {
          quickLogisticsValue = item.detailUsePoint
        }
      })
      return mathUtils.floatSub(this.itemPointValueAll, quickLogisticsValue)
    },
    logisticsPointValue () {
      return this.freightState ? this.channelInfo.logisticsPointValue : 0
    }
  },
  watch: {
    calculatedOrderPoint: {
      handler () {
        this.vipCardDiscountList = this.vipCardDiscount()
      }
    }
  },
  methods: {

    handleLogin () {
      console.log('22222')
      wxAppApi
        .isNeedUpdatePassword()
        .then(res => {
          this.$toast.clear()
          if (res.data.resultCode === '0') {
            console.log('333')

            var oldfullPath = {
              fullPath: 'orderCreate',
              clientId: JSON.parse(localStorage.getItem('userInfo')).clientInfo.clientId
            }
            console.log('555', oldfullPath)
            if (res.data.resultData.needChangePassword === 1) {
              localStorage.setItem('oldfullPath', JSON.stringify(oldfullPath))
              this.$router.push({ name: 'forget-password', query: { loginStatus: true } })
            } else {
              this.beforeOrderCreate()
            }
          }
        })
        .catch(() => {
          this.$toast.clear()
        })
    },
    // vip卡针对 终端支持（210） 分类外的其它商品，进行折扣
    vipCardDiscount () {
      let vipCardDiscount = []
      if (this.vipCardInfo.cardId && this.showVipCardReduce()) {
        this.vipCardDiscountPoint = _.cloneDeep(this.calculatedOrderPoint)
        for (let i = 0; i < this.vipCardDiscountPoint.length; i++) {
          vipCardDiscount.push(this.vipCardDiscountPoint[i])
          let discountRate = mathUtils.floatSub(1, Number(this.vipCardInfo.exchangeRatio))
          vipCardDiscount[i].pointValue = mathUtils.floatMul(Number(this.vipCardDiscountPoint[i].pointValue), discountRate)
          vipCardDiscount[i].pointValue = Math.floor(vipCardDiscount[i].pointValue)
        }
      }
      return vipCardDiscount
    },
    init () {
      let handleType = this.$route.params.type
      let newAddressId = this.$route.params.newAddressId || null
      this.selectCouponId = this.$route.params.selectCouponId || ''
      if (handleType !== 'sub') {
        this.getAddressList(newAddressId)
      } else {
        this.selectAddress = {
          addressId: this.$route.params.newAddressId,
          contactPerson: this.$route.params.contactPerson,
          contactMobile: this.$route.params.contactMobile,
          detailAddress: this.$route.params.detailAddress
        }
      }
      this.queryPointList()
      this.queryVipCard()
      this.initCreateOrder()
    },
    // 收货地址
    getAddressList (newAddressId) {
      this.$store.dispatch('getAddress').then(response => {
        this.addressList = response
        for (var i = 0; i < this.addressList.length; i++) {
          if (newAddressId === null) {
            // 收货地址取默认的收货地址
            if (this.addressList[i].isDefault === 1) {
              this.selectAddress = this.addressList[i]
            }
          } else if (newAddressId !== null) {
            // $stateParams.newAddressId有值表示已修改收货地址
            if (this.addressList[i].addressId === newAddressId) {
              this.selectAddress = this.addressList[i]
            }
          }
        }
      })
    },
    queryPointList () {
      centerApi.queryPointList().then(res => {
        if (res.data.resultCode === '0') {
          this.pointList = res.data.resultData.pointList
          for (var i = 0, len = this.pointList.length; i < len; i++) {
            // if (this.pointList[i].pointType === '1') {
            //   this.yijiaName = this.pointList[i].pointTypeName
            // } else {
            //   this.posName = this.pointList[i].pointTypeName
            // }
          }
        }
      })
    },
    queryVipCard () {
      centerApi.queryVipCard().then(res => {
        if (res.data.resultCode === '0') {
          const { vipCardInfo } = res.data.resultData
          this.vipCardInfo = vipCardInfo || {}
        }
      })
    },
    initCreateOrder () {
      cartApi.initCreateOrder().then(res => {
        if (res.data.resultCode === '0') {
          // quickLogisticsItem 加急| logisticsItem 运费
          const { orderItems, orderPoint, presentList, channelInfo, quickLogisticsItem, logisticsItem, couponList } = res.data.resultData

          this.orderPoint = orderPoint || []
          this.presentList = presentList || []
          this.orderItems = orderItems || []
          this.logisticsItem = logisticsItem || {}
          this.quickLogisticsItem = quickLogisticsItem || {}

          this.channelInfo = channelInfo || []
          this.channelInfo.limitOrderPoint = this.channelInfo.limitOrderPoint || 0
          this.channelInfo.logisticsPointValue = this.channelInfo.logisticsPointValue || 0
          this.channelInfo.logisticsPointType = this.logisticsItem.firstPointType || ''
          this.channelInfo.logisticsPointTypeName = this.logisticsItem.firstPointTypeName || ''

          this.couponList = couponList || []
          let selectedCouponId = this.$route.params.selectCouponId || ''
          for (let i in this.couponList) {
            if (this.couponList[i].couponItemIds) {
              let hasItem = this.orderItems.some(item => {
                return this.couponList[i].couponItemIds.includes(item.itemId)
              })
              if (hasItem) {
                if (this.couponList[i].couponId === selectedCouponId) {
                  this.couponId = selectedCouponId
                  break
                }
              }
            } else {
              if (this.couponList[i].couponId === selectedCouponId) {
                this.couponId = selectedCouponId
                break
              }
            }
          }
          this.freightItem = {
            itemId: this.logisticsItem.itemId,
            itemImageUri: this.logisticsItem.itemImageUri,
            itemName: this.logisticsItem.itemName,
            itemCode: this.logisticsItem.itemCode,
            pointValue: this.logisticsItem.exchangePoint,
            pointTypeName: this.logisticsItem.firstPointTypeName,
            itemQuantity: Math.round(this.channelInfo.logisticsPointValue / this.logisticsItem.exchangePoint),
            detailUsePoint: this.channelInfo.logisticsPointValue
          }
          if (couponList) {
            this.couponList = couponList
            for (let coupon of this.couponList) {
              this.couponCount += coupon.couponCount
            }
          }
        }
      })
    },

    getImageUri (mobileImageUri) {
      return process.env.VUE_APP_EXTRA_SITE + mobileImageUri
    },
    // 选择卡券
    goSelectCoupon () {
      // let selectAddressId = this.addressList ? this.addressList.addressId : null;
      this.$router.replace({
        name: 'selectCoupon',
        params: {
          selectCouponId: this.selectCouponId,
          selectAddressId: this.selectAddress.addressId
        }
      })
    },
    // 更换地址
    toReceivingAddress () {
      this.$router.replace({
        name: 'receivingAddress',
        params: {
          selectAddress: 0,
          selectCouponId: this.selectCouponId
        }
      })
    },
    // 取消订单
    orderCancel () {
      this.$router.push({
        name: 'home-main'
      })
    },

    showVipCardReduce () {
      let allowVipDiscount = true
      for (let i in this.orderItems) {
        if (this.orderItems[i].itemCategoryCode === '210') {
          allowVipDiscount = false
        }
      }
      return this.vipCardInfo.cardId && allowVipDiscount
    },
    // 判断中秋订单是否满2w积分
    beforeOrderCreate () {
      let regex = /^(1[3-9]\d{9})$|^(\d{8})$|^(\d{9})$/
      if (!regex.test(this.selectAddress.contactMobile || this.selectAddress.receivePhone)) {
        this.$toast('收货手机号异常,请修改手机号！')
        return false
      }
      let total = 0
      for (let item in this.orderItems) {
        if (this.orderItems[item].pointType === '1') {
          total += parseInt(this.orderItems[item].detailUsePoint)
        }
      }
      if (total > 20000) {
        this.orderCreate()
      } else {
        let timestamp = (new Date()).valueOf()
        if (timestamp > 1632153600000 && timestamp < 1633104000000) {
          activityApi.getMidAutumnRecordList().then(res => {
            if (res.data.resultCode === '0') {
              if (res.data.resultData.prevent) {
                this.orderCreate()
              } else {
                let midAutumnRecordCount = res.data.resultData.midAutumnRecordCount
                if (midAutumnRecordCount < 10) {
                  this.dialogVisible = true
                } else {
                  this.orderCreate()
                }
              }
            }
          }).catch(() => {
          })
        } else {
          this.orderCreate()
        }
      }
    },

    orderCreate () {
      if (!this.selectAddress || !this.selectAddress.addressId) {
        this.$toast('请选择收货地址')
        return
      }
      if (this.userRole === '03') {
        this.$toast('没有下单权限')
        return
      }
      // if (this.addressList.length === 0) {
      //   this.$message({type: 'error', message: '还没有地址,请新建收货地址再订购!'});
      //   return;
      // }
      this.orderList = []
      for (let item in this.orderItems) {
        if (!this.orderItems[item].activityId) {
          this.orderList.push({
            itemId: this.orderItems[item].itemId,
            itemQuantity: this.orderItems[item].itemQuantity,
            cartIds: this.orderItems[item].cartIds
          })
        }
      }
      if (this.freightState) {
        this.orderList.push({ itemId: this.freightItem.itemId, itemQuantity: this.freightItem.itemQuantity })
      }
      let params = {
        addressId: this.selectAddress.addressId,
        orderRemark: '订单备注',
        detailList: this.orderList,
        couponId: this.selectCouponId,
        activityId: this.activityId,
        presentItemQty: this.activityId ? this.presentItem.itemQuantity : 0
      }

      if (this.freightState) {
        this.$dialog.alert({
          message: `该订单需要付运费:${this.channelInfo.logisticsPointValue}(${this.channelInfo.logisticsPointTypeName}),是否同意?`,
          title: '温馨提示',
          showCancelButton: true,
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          this.submitOrderCreateCheck(params)
        }).catch(() => { })
      } else {
        this.submitOrderCreateCheck(params)
      }
    },
    findPresentItem (activityId) {
      this.presentItem = {}
      for (let item in this.presentList) {
        if (this.presentList[item].activityId === activityId) {
          this.presentItem = {
            itemId: this.presentList[item].itemDTO.itemId,
            itemImageUri: this.presentList[item].itemDTO.itemImageUri,
            itemName: this.presentList[item].itemDTO.itemName + '(赠品)',
            itemCode: this.presentList[item].itemDTO.itemCode,
            pointValue: this.presentList[item].addPay,
            pointTypeName: this.presentList[item].addPayTypeName,
            pointType: this.presentList[item].addPayType,
            itemQuantity: this.getPresentItemUpLimit(this.presentList[item]),
            detailUsePoint: mathUtils.floatMul(this.presentList[item].addPay, this.getPresentItemUpLimit(this.presentList[item])),
            activityId: activityId
          }
          break
        }
      }
    },
    getPresentItemUpLimit (present) {
      return present.upLimit > present.stockQty ? present.stockQty : present.upLimit
    },
    pushItemInfo (activityId) {
      if (activityId === '') {
        this.removePresentItem()
        return
      }
      this.findPresentItem(activityId)
      if (!this.presentItem.itemId) {
        return
      }
      this.removePresentItem()
      this.orderItems.push(this.presentItem)
    },
    removePresentItem () {
      for (let i = 0; i < this.orderItems.length; i++) {
        // eslint-disable-next-line
        if (!!this.orderItems[i].activityId) {
          this.orderItems.splice(i, 1)
        }
      }
    },
    submitOrderCreateCheck (params) {
      cartApi.checkCreate(params).then((response) => {
        if (response.data.resultCode === '0') {
          if (!!response.data.resultData && !!response.data.resultData.useSecond && !!response.data.resultData.useSecondRemark) {
            this.$dialog.confirm({
              message: response.data.resultData.useSecondRemark,
              title: '温馨提示',
              showCancelButton: true,
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              this.submitOrderCreate(params)
            }).catch(() => { })
          } else {
            this.submitOrderCreate(params)
          }
        }
      })
    },
    submitOrderCreate (params) {
      if (this.submitLoading) {
        return
      }
      this.$toast.loading({
        duration: 0,
        message: '加载中...',
        forbidClick: true
      })
      this.submitLoading = true
      cartApi.createOrder(params).then((response) => {
        this.$toast.clear()
        if (response.data.resultCode === '0') {
          this.$toast('创建订单成功!')
          let isUserCoupon = (this.selectCouponId !== null)
          if (response.data.resultData.activityPrize) {
            let paramsData = {
              orderId: response.data.resultData.orderInfo.orderId,
              form: true,
              fromOrderList: true,
              itemId: this.orderItems[0].itemId,
              isUserCoupon: isUserCoupon,
              activityPrize: response.data.resultData.activityPrize
            }
            if (this.orderItems[0].itemCategoryCode !== '501') {
              this.$router.push({
                name: 'orderDetail',
                params: paramsData
              })
            } else if (this.orderItems[0].itemCategoryCode === '501') {
              //  this.initCreateOrder()
              this.$router.push({
                name: 'knowledge-goods',
                query: paramsData
              })
            }
          } else {
            let paramsData = {
              orderId: response.data.resultData.orderInfo.orderId,
              form: true,
              fromOrderList: true,
              itemId: this.orderItems[0].itemId,
              isUserCoupon: isUserCoupon
            }
            if (this.orderItems[0].itemCategoryCode !== '501') {
              this.$router.push({
                name: 'orderDetail',
                params: paramsData
              })
            } else if (this.orderItems[0].itemCategoryCode === '501') {
              //  this.initCreateOrder()
              this.$router.push({
                name: 'knowledge-goods',
                query: paramsData
              })
            }
          }

          // }
        } else {
          // this.$message({ type: 'error', message: response.data.resultMsg });
        }
        this.submitLoading = false
      }).catch(() => {
        this.submitLoading = false
        this.$toast.clear()
      })
    }
  }
}
</script>
<style scoped lang="less">
.address-info {
  font-size: 0.3rem;
  padding: 0.3rem;
  display: flex;
  background-color: #fff;
  align-items: center;
  height: 2rem;

  .address-content {
    flex: 1 1 auto;
    margin: 0 0.4rem;

    .address-content-l {
      margin: 0.2rem 0rem;
    }
  }

  .forward-icon-wrapper {
    width: 0.34rem;
    height: 0.6rem;
    flex: 0 0 auto;
  }
}

.padding-x-3 {
  padding: 0 0.3rem;
}

.order-list {
  border: 1px solid #fff;
  background-color: #f1f1f1;
  display: flex;
  height: auto;
  margin: 0.3rem 0rem;

  .order-item-img {
    width: 2.8rem;
    height: 2.8rem;

  }

  .order-item-content {
    min-height: 2.8rem;
    height: auto;
    flex: 1;
  }

  .point-red {
    color: #e20015;

    span {
      font-size: 0.4rem;
    }
  }
}

.ticket {
  padding-bottom: 1.5rem;

  .ticket-integration {
    margin-right: 1rem;

    span {
      color: var(--base-green);
    }
  }

  .cell-icon {
    padding-right: 0.3rem
  }

  .van-cell {
    font-size: 0.35rem;
    align-items: center !important;
  }
}

.color-green {
  color: var(--base-green) !important;
}

.color-base-green {
  color: #4e953d !important;
}

.color-orange {
  color: #c36c4d;
}

.fixed {
  height: 1.5rem;

  .point {
    text-align: center;
    color: #c36c4d;
    flex: 0 0 34%;
    background-color: #fff;
    line-height: 0.7rem;
    font-size: 0.3rem;
  }

  button {
    height: 100%;
    flex: 0 0 33%;
  }
}
</style>
